var _templateObject = _taggedTemplateLiteralLoose(["\n    font-size: ", ";\n    line-height: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n    margin-bottom: ", ";\n  "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from "react";
import styled from "styled-components";
import { media } from "../../index";
import { lineHeightFromSize } from "./utils";
import { safeElement } from "../../utils";

export var TypographyStyled = styled(safeElement()).withConfig({
  displayName: "atoms__TypographyStyled",
  componentId: "m4h2r3-0"
})(["font-display:swap;display:", ";font-weight:", ";", ";text-transform:", ";margin:0;color:", ";", ";letter-spacing:", ";", ";", ";", ";", ";"], function (props) {
  return "" + props.display;
}, function (props) {
  return props.bold ? "bold" : "normal";
}, function (props) {
  return props.extraBold && "font-weight: 800;";
}, function (props) {
  return props.uppercase ? "uppercase" : "normal";
}, function (props) {
  return props.color;
}, function (props) {
  return props.theme.typoTextAlign && "\n      text-align: " + props.theme.typoTextAlign + ";\n      padding: 0 1rem;\n    ";
}, function (props) {
  return props.uppercase ? "0.1em" : "0.02em";
}, media.phone(_templateObject, function (props) {
  return props.size[0] + "em";
}, function (props) {
  return lineHeightFromSize(props.size[0]) + "em";
}, function (props) {
  return props.gutterBottom[0];
}), media.tablet(_templateObject, function (props) {
  return props.size[1] + "em";
}, function (props) {
  return lineHeightFromSize(props.size[1]) + "em";
}, function (props) {
  return props.gutterBottom[1];
}), media.desktop(_templateObject, function (props) {
  return props.size[2] + "em";
}, function (props) {
  return lineHeightFromSize(props.size[2]) + "em";
}, function (props) {
  return props.gutterBottom[2];
}), media.wide(_templateObject, function (props) {
  return props.size[3] + "em";
}, function (props) {
  return lineHeightFromSize(props.size[3]) + "em";
}, function (props) {
  return props.gutterBottom[3];
}));